export var feedbackServiceTriggerSelector = function (state) { return state.content; };
export var feedbackServiceLoadingSelector = function (state) { return state.loading; };
